<template>
  <div class="userDialog">
    <el-dialog
      class="userTemplate"
      title="选择组织机构下人员"
      top="5px"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      :before-close="handleClose"
      :show-close="true"
      @opened="openedDialog"
      center
      append-to-body
    >
      <el-container>
        <el-aside
          width="180px"
          style="height:100%;min-height:550px;border-right: 1px solid rgb(181, 181, 181);"
        >
          <templateTag
            ref="templateTag"
            @openSearch="openSearch3"
            style="height: 90%;background-color: #ffffff;"
            @getAllTask="getAllTask"
            class="templateTag fl"
            :index-tit="templateTitle"
            :columns="columns"
          />
        </el-aside>
        <el-container>
          <el-header height="30px">
            <el-row>
              <el-col
                :span="15"
                id="userTemplateSearch"
              >
                <el-tag
                  v-for="(sea) in searchCondition"
                  :key="sea.key + sea.title"
                >
                  {{ sea.title }} : {{ sea.value }}
                </el-tag>&nbsp;
              </el-col>
              <el-col :span="3">
                <!-- <img class="beforeIcon" v-bind:class="{ isActiveClass : isActive }" @click="toShow" src="../../assets/img/箭头.png" height="28px"> -->
                <el-button
                  @click="searchTask"
                  class="fr"
                  size="mini"
                  type="warning"
                  round
                >
                  精确搜索
                </el-button>
              </el-col>
              <el-col :span="6">
                <!-- <el-button @click="searchTask" size="mini" type="warning" round>精确搜索</el-button> -->
                <el-input
                  style="margin-left: 5px;"
                  placeholder="输入名称,简拼可模糊查找。。。"
                  v-model="filterText"
                  size="mini"
                />
              </el-col>
            </el-row>
          </el-header>
          <el-main>
            <el-row style="border-top:1px solid #B5B5B5;">
              <el-col
                :span="leftCol"
                style="text-align: center;"
              >
                <div style="height:500px;">
                  <el-scrollbar style="height: 100%;">
                    <!-- <el-tree class="filter-tree" :data="allData" :props="defaultProps" @node-click="handleNodeClick" accordion :check-strictly="isStrictly" :default-checked-keys="expandedKeys" :show-checkbox="!isStrictly" node-key="ID" :filter-node-method="filterNode" @check-change="checkChange"
                                            highlight-current ref="companyTree">
                                            <span class="custom-tree-node" slot-scope="{ node, data }">

<span style="padding-bottom: 0px;" v-on:dblclick="dblclickToSure(data)">

<img v-if="data.Type==1" src="../../assets/img/机构.png" height="20px">

<img v-if="data.Type==2" src="../../assets/img/人员.png" height="20px">

<img v-if="data.Type==3" src="../../assets/img/组织.png" height="20px">

{{ node.label }}

</span>
                                            </span>
                    </el-tree>-->
                    <el-table
                      v-loading="loading"
                      @current-change="handleCurrentChange"
                      ref="multipleTable"
                      :data="allData"
                      highlight-current-row
                      @selection-change="handleSelectionChange"
                      style="width: 100%"
                    >
                      <el-table-column
                        v-show="!isRadio"
                        :type="isRadio?'':'selection'"
                        width="55"
                      />
                      <el-table-column
                        label="姓名"
                        width="120"
                      >
                        <template slot-scope="scope">
                          <ChatUser
                            style="float: left;margin-right:2px"
                            :user-info="{id:scope.row.ID,name:scope.row.Name}"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="Sex"
                        label="性别"
                        width="50"
                      />
                      <el-table-column
                        prop="Code"
                        label="工号"
                        width="90"
                      />
                      <el-table-column
                        prop="Phone"
                        label="手机号"
                        width="130"
                      />
                      <el-table-column
                        prop="DeptName"
                        label="所属组织"
                        width="140"
                      />
                      <el-table-column
                        label="微信绑定"
                        width="80"
                      >
                        <template slot-scope="scope">
                          <el-tag
                            effect="dark"
                            :type="scope.row.OpenId?'success':'danger'"
                          >
                            {{ scope.row.OpenId?'是':'否' }}
                          </el-tag>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-scrollbar>
                </div>
              </el-col>
              <el-col
                :span="rightCol"
                style="text-align: center;border-left:1px solid #B5B5B5;height: 500px;"
              >
                <div v-if="showRightCol==true && !expand">
                  <div style="padding: 8px 0px 10px 0px;background-color: rgb(218, 240, 247)">
                    <span style="font-size: 18px;">选中人员如下</span>
                  </div>
                  <div>
                    <el-table
                      :data="tableData"
                      height="445px"
                      border
                      style="width: 100%"
                      header-align="center"
                      size="medium"
                    >
                      <el-table-column label="姓名">
                        <template slot-scope="scope">
                          <div
                            slot="reference"
                            class="name-wrapper"
                          >
                            <el-tag
                              effect="plain"
                              closable
                              @close="handleDelete(scope.$index, scope.row)"
                            >
                              {{ scope.row.Name }}
                            </el-tag>
                            <!-- <el-link type="primary"
                            :underline="false">{{ scope.row.Name }}</el-link>-->
                            <!-- <el-tag   effect="dark" >{{ scope.row.Name }}</el-tag> -->
                          </div>
                        </template>
                      </el-table-column>
                      <!-- <el-table-column label="操作">
                        <template slot-scope="scope">
                          <el-button style="padding:2px"
                                     type="danger"
                                     size="mini"
                                     icon="el-icon-close"
                                     @click="handleDelete(scope.$index, scope.row)"
                                     circle>

                          </el-button>
                        </template>

                      </el-table-column>-->
                    </el-table>
                    <div
                      style="text-align: center; margin-top: 2px;"
                      v-show="!isRadio"
                    >
                      <el-button
                        type="primary"
                        size="mini"
                        style="padding:7px"
                        @click="toSure('')"
                      >
                        确认返回
                      </el-button>
                      <el-button
                        size="mini"
                        style="padding:7px"
                        @click="createTemplate"
                      >
                        存为模板
                      </el-button>
                      <el-button
                        size="mini"
                        style="padding:7px"
                        @click="toCloseForm"
                      >
                        清空
                      </el-button>
                    </div>
                  </div>
                </div>
                <Suspension
                  v-show="expand"
                  ref="Suspension"
                  @detailsEvent="DetailsEvent"
                  :columns="columns"
                  :is-detailed="false"
                />
              </el-col>
            </el-row>
          </el-main>
          <el-footer v-show="isRadio">
            <div style="text-align: left;">
              <el-button
                type="primary"
                size="mini"
                style="padding:7px"
                @click="toSure('')"
              >
                确认返回
              </el-button>
              <el-button
                size="mini"
                style="padding:7px"
                @click="toCloseForm"
              >
                取消
              </el-button>
            </div>
          </el-footer>
        </el-container>
      </el-container>
      <createTemplate
        ref="createTemplate"
        :user-id="userId"
        :body="true"
        @guanbi="guantc"
        :tem-type="0"
      />
      <!-- <div class="suspension">

<el-button type="primary" @click="operationPanel" :icon="expand?'el-icon-d-arrow-right':'el-icon-d-arrow-left'"

 circle></el-button>

      </div>-->
    </el-dialog>
    <userSearchDialog
      ref="userSearchDialog"
      :search-method="SearchAsync"
    />
  </div>
</template>

<script>
import {
  getAllUser,
  GetUserTreeByCustomerGroup
} from "@/api/modules/basicData/personnel";
import {
  GetAllCustomerVWInfo,
  GetListDeptByCompanyExId,
  GetTemplateUserSearchResult,
  GetTemplateUserSearchResultByTemplateID
} from "@/api/modules/basicData/organization";
import { listToTree } from "@/api/modules/basicData/commonData";
import searchJs from "@/util/search";
import createTemplate from "../template/createTemplate.vue";
import templateTag from "../template/templateTag.vue";
import userSearchDialog from "@/components/basicTemplate/userSearchDialog.vue";
import Suspension from "../template/suspension.vue";
import ChatUser from "@/views/task/Chat/ChatUser.vue";
export default {
  name: "SelectAllUser",
  components: {
    templateTag,
    userSearchDialog, //:()=>import("@/components/basicTemplate/userSearchDialog.vue"),
    ChatUser,
    createTemplate,
    Suspension
  },
  data() {
    return {
      dataIniting: false,
      currentRow: {}, //单选时当前选中行
      //  userSearchDialogVisible: false,
      templateTitle: "人员面板管理",
      expand: false, //是否显示
      formAllData: {
        institution: "",
        organization: ""
      },
      expandedKeys: [],
      expandedKeys1: [],
      dataForIsRadio: {},
      userList: [],
      mechList: "",
      deleteArr: [],
      deptList: "",
      tabsName: "secondTree",
      leftCol: 17,
      rightCol: 7,
      showRightCol: true,
      dialogWidth: "70%",
      isActive: false,
      isActive1: false,
      tableData: [],
      userName: "",
      dialogVisible: false,
      filterText: "",
      filterText1: "",
      data1: [],
      allData: [],
      treeList: [],
      treeList1: [],
      dataList: [],
      addBtn: false,
      inputDis: false,
      editCheckId: "",
      loading: false,
      loading1: false,
      innerVisible: false,
      myWidth: "",
      isStrictly: false,
      editCheckIdArr: [],

      unverifiedSelectedUser: [],
      selectedUser: [],
      defaultProps: {
        id: "ID",
        children: "children",
        label: "Name"
      },
      data: [],
      show: false,
      show1: false,
      isBtn1: true,
      isBtn2: false,
      columns: [
        {
          text: "姓名",
          value: "Name"
        }
      ]
    };
  },
  props: {
    isRadio: Boolean,
    setWidth: {
      type: String,
      default: "250px"
    },
    userId: {
      type: String,
      default: ""
    }

    // idArray: {
    //     type: Array,
    //     default: function() {
    //         return []
    //     }
    // },
  },
  watch: {
    filterText(val) {
      this.debouncedSearch(val);
    },
    filterText1(val) {
      this.debouncedSearch1(val);
    },
    userName(val, oldVal) {
      if (val == "") {
        this.addBtn = false;
      } else {
        this.addBtn = false;
      }
    },
    // 'idArray': {
    //     handler(val, oldVal) {
    //         if (val.length > 0) {
    //           console.log("allUserDialog idArray");
    //             if (this.treeList.length == 0) {
    //                 getAllUser(this.userId, '', 0).then(res => {
    //                          console.log("allUserDialog res");
    //                     this.unverifiedSelectedUser = []
    //                     this.tableData=res;
    //                        this.editCheckIdArr=this.tableData.map(t=>t.ID);
    //                     res.forEach((c) => {
    //                         for (var i = 0; i <= this.idArray.length; i++) {
    //                             if (c.Type == 2 && c.UserId == this.idArray[i] && this.checkIsExit(this.unverifiedSelectedUser, c) == true) {
    //                                 this.unverifiedSelectedUser.push(c)
    //                             }
    //                         }
    //                     })
    //                     this.transferValue(this.unverifiedSelectedUser)
    //                     this.assignmentInput()
    //                 }).catch(res => {
    //                     console.log('异常原因：' + res);
    //                 })
    //             } else {
    //                 this.unverifiedSelectedUser = []
    //                 this.treeList.forEach((c) => {
    //                     for (var i = 0; i <= this.idArray.length; i++) {
    //                         if (c.Type == 2 && c.UserId == this.idArray[i] && this.checkIsExit(this.unverifiedSelectedUser, c) == true) {
    //                             this.unverifiedSelectedUser.push(c)
    //                                 this.tableData.push(c);
    //                         }
    //                     }
    //                 })
    //                 this.transferValue(this.unverifiedSelectedUser)
    //                 this.assignmentInput()
    //             }
    //         } else {
    //             this.unverifiedSelectedUser = []
    //             this.selectedUser = []
    //             this.transferValue(this.unverifiedSelectedUser)
    //             this.assignmentInput()
    //         }
    //     },
    //     deep: true //深度监听
    // },
    selectedUser: {
      handler(val, oldVal) {
        if (val.length > 0) {
          this.inputDis = true;
        }
      },
      deep: true //深度监听
    },
    "formAllData.institution": {
      //每次改变执行
      handler(val, oldVal) {
        if (val != oldVal) {
          this.formAllData.organization = "";
          this.getDeptList(val);
        }
      },
      deep: true //深度监听
    }
  },
  mounted() {
    // this.alertDialog()
    this.$root.$on("amendSearch", data => {
      this.redact(data);
    });
    // this.$root.$on('morenTemp', data => {
    //     this.morenTempS(data)
    // })
    // this.$root.$on('search', data => {
    //     this.$refs.userSearch.SearchOpen(data)
    // })
  },
  created() {
    var _ = require("lodash");
    this.debouncedSearch = _.debounce(this.getkeywordUser, 1000);
    this.getMechList();
    this.checkSource();
    this.setOption();
  },
  methods: {
    guantc() {},
    createTemplate() {
      // searchJs.queryTaskTitle(this.getPara());
      this.$refs.createTemplate.open();

      this.$refs.createTemplate.content = JSON.stringify(this.tableData);
    },
    openSearch3(data) {
      // console.log('创建模板----mb0111')
      this.$refs.userSearchDialog.SearchOpen(data);
    },
    DetailsEvent(row) {},
    operationPanel() {
      //操作结果库面板是否显示
      if (this.expand) {
        this.expand = false;
        if (this.isRadio == true) {
          this.isStrictly = true;
          this.leftCol = 24;
          this.rightCol = 0;
          this.showRightCol = false;
        }
      } else {
        this.expand = true;
        if (this.isRadio == true) {
          this.leftCol = 17;
          this.rightCol = 7;
          this.isStrictly = false;
          this.showRightCol = true;
        }
      }
      console.log("结果集:", this.expand);
    },
    // setEditData() {
    //     getAllUser(this.userId, '', 0).then(res => {
    //         this.unverifiedSelectedUser = []
    //         res.forEach((c) => {
    //             for (var i = 0; i <= this.idArray.length; i++) {
    //                 if (c.Type == 2 && c.UserId == this.idArray[i] && this.checkIsExit(this.unverifiedSelectedUser, c) == true) {
    //                     this.unverifiedSelectedUser.push(c)
    //                 }
    //             }
    //         })
    //         this.transferValue(this.unverifiedSelectedUser)
    //         this.assignmentInput()
    //     }).catch(res => {
    //         console.log('异常原因：' + res);
    //     })
    // },
    checkIsExit(arr, obj) {
      var filter = true;
      arr.forEach(c => {
        if (c.UserId == obj.UserId) {
          filter = false;
        }
      });
      return filter;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    searchTree() {
      this.getUser(
        this.filterText,
        this.formAllData.institution,
        this.formAllData.organization
      );
    },
    handleNodeClick(data) {
      if (data.Type == 2) {
        this.dataForIsRadio = data;
      }
    },
    dblclickToSure(data) {
      if (this.isRadio == true && data.Type == 2) {
        this.toSure(data);
      }
    },
    handleDelete(index, row) {
      this.updateTable(row.ID);
      // var temporaryTreeArr = this.$refs.companyTree.getCheckedNodes()
      // for (var i = 0; i < temporaryTreeArr.length; i++) {
      //     if (temporaryTreeArr[i].ID == row.ID) { //如果ID一样视为同一人，取消选中
      //         this.$refs.companyTree.setChecked(temporaryTreeArr[i].Id, false)
      //     }
      // }
      if (this.allData.indexOf(row) > -1) {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    updateTable(code) {
      // this.tableData.indexOf()
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].ID === code) {
          this.tableData.splice(i, 1);
          this.editCheckIdArr.splice(i, 1);
        }
      }
    },
    toShow() {
      this.show = !this.show;
      this.isActive = !this.isActive;
    },
    toShow1() {
      this.show1 = !this.show1;
      this.isActive1 = !this.isActive1;
    },
    getMechList() {
      GetAllCustomerVWInfo()
        .then(res => {
          this.mechList = res;
        })
        .catch(res => {
          this.mechList = [];
          console.log("Error! Could not reach the API. " + res);
        });
    },
    getDeptList(mechID) {
      var mechID_Int = parseInt(mechID);
      GetListDeptByCompanyExId(this.userId, mechID_Int)
        .then(res => {
          this.deptList = res;
        })
        .catch(res => {
          console.log("Error! Could not reach the API. " + res);
        });
    },
    getArrDifference(arr1, arr2) {
      return arr1.concat(arr2).filter(function(v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    },
    reset() {
      this.addBtn = false;
      this.inputDis = false;
      this.userName = "";
      this.tableData = [];
      this.dataForIsRadio = {};
      this.editCheckIdArr = [];

      this.selectedUser = []; //最终值
      this.unverifiedSelectedUser = []; //待验证值
      // this.$emit("getValue", this.selectedUser, function(str) { //传递值，无论是否验证
      //     console.log('清理完成')
      // });
    },
    querySearchAsync(queryString, cb) {
      getAllUser(this.userId, queryString, 1)
        .then(res => {
          var result = [];
          res.forEach(c => {
            var obj = {};
            if (c.Type == 2) {
              obj.value = c.Name;
              obj.Name = c.Name2;
              obj.Id = c.Id;
              obj.UserId = c.UserId;
              obj.Type = c.Type;
              result.push(obj);
            }
          });
          cb(result);
        })
        .catch(res => {
          console.log("异常原因：" + res);
        });
    },
    SearchAsync(userPara) {
      //获取人员数据
      this.GetTemplateUserSearchResult(userPara);
      this.$refs.userSearchDialog.userSearchDialogVisible = false;
      // GetTemplateUserSearchResult(userPara).then(res => {
      //         var result = []
      //         res.forEach((c) => {
      //             var obj = {}
      //             if (c.Type == 2) {
      //                 obj.value = c.Name
      //                 obj.Name = c.Name2
      //                 obj.Id = c.Id
      //                 obj.UserId = c.UserId
      //                 obj.Type = c.Type
      //                 result.push(obj)
      //             }
      //         })
      //     })
      //     .catch(res => {
      //         console.log('异常原因：' + res);
      //     })
    },
    handleSelect(item) {
      this.addBtn = false;
      this.inputDis = true;
      this.unverifiedSelectedUser.push(item);
      this.editCheckIdArr.push(item.ID);
      this.transferValue(this.unverifiedSelectedUser);
    },
    setOption() {
      if (this.setWidth != "") {
        this.myWidth = this.setWidth;
      }
    },
    checkSource() {
      if (this.isRadio == true) {
        this.isStrictly = true;
        this.leftCol = 24;
        this.rightCol = 0;
        this.showRightCol = false;
      } else {
      }
    },
    searchNodeById(Id, treeData) {
      for (var i = 0; i < treeData.length; i++) {
        if (treeData[i].Id == Id) {
          //找到后遍历孩子
          this.searchTreeChilren(treeData[i]);
          break;
        } else {
          if (treeData[i].hasOwnProperty("children")) {
            this.searchNodeById(Id, treeData[i].children);
          }
        }
      }
    },
    searchTreeChilren(treeData) {
      if (treeData.hasOwnProperty("children")) {
        for (var i = 0; i < treeData.children.length; i++) {
          if (treeData.children[i].Type == 2) {
            this.deleteArr.push(treeData.children[i]);
          } else {
            this.searchTreeChilren(treeData.children);
          }
        }
      }
    },
    checkAllTree(code, trueOrFalse) {
      for (var i = 0; i < this.treeList.length; i++) {
        if (this.treeList[i].ID == code) {
          this.$refs.multipleTable.toggleRowSelection(
            this.treeList[i],
            trueOrFalse
          );
          //this.$refs.companyTree.setChecked(this.treeList[i].Id, trueOrFalse)
        }
      }
    },
    handleSelectionChange(val) {
      console.log("handleSelectionChange", val);
      if (val.length === 0 && this.dataIniting) {
        //点击模板或者查找后等待数据刷新后再加载选中项
        this.dataIniting = false;
        var checkRows = this.allData.filter(
          o => this.editCheckIdArr.indexOf(o.ID) > -1
        );
        console.log("checkRows", checkRows);
        checkRows.forEach(row => {
          console.log("indexOf", this.allData.indexOf(row));
          if (row) this.$refs.multipleTable.toggleRowSelection(row);
        });
        return;
      }
      //已选中和未选中 ，已选中的加到右边，未选中的从右边删除
      val.forEach(item => {
        console.log(this.editCheckIdArr.indexOf(item.ID));
        if (this.editCheckIdArr.indexOf(item.ID) === -1) {
          this.tableData.push(item);
        }
      });
      var uncheckData = this.allData.filter(t => val.indexOf(t) === -1);
      uncheckData.forEach(item => {
        let index = this.editCheckIdArr.indexOf(item.ID);
        if (index > -1) {
          this.tableData.splice(index, 1);
        }
      });
      this.editCheckIdArr = this.tableData.map(item => item.ID);
      console.log("tableData", this.tableData);
    },
    //所有人员树，实现单双选以及过滤非人员
    checkChange(item, node, self) {
      if (this.expand) {
        //结果集
        if (node == true) {
          //点击未选中复选框
          this.$store.commit("addResult", {
            row: item,
            bol: true
          });
        } else {
          this.$store.commit("addResult", {
            row: item,
            bol: false
          });
        }
      } else {
        //勾选
        if (this.isRadio == true) {
        } else {
          if (node == true) {
            //点击未选中复选框
            if (this.editCheckIdArr.indexOf(item.ID) == -1) {
              //不包含该元素
              this.editCheckIdArr.push(item.ID);
              item.treeType = 0;
              this.tableData.push(item);
              this.checkAllTree(item.ID, true);
            }
          } else {
            //已选中
            this.checkAllTree(item.ID, false);
            this.updateTable(item.Id);
          }
        }
      }
    },
    alertDialog() {
      this.selectedUser.forEach(c => {
        this.tableData.push(c);
      });
      // if (this.allData.length == 0) {
      //     this.getTreeData('')
      // }
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.filterText = "";
      this.editCheckId = "";
      this.editCheckIdArr = [];
      this.tableData = [];
      this.$store.commit("setResult", []);
      this.$refs.multipleTable.clearSelection();
      this.allData = [];
      // this.$refs.companyTree.setCheckedKeys([]);
      done();
    },
    open(title, message) {
      this.$alert(message, title, {
        confirmButtonText: "确定"
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.Name.indexOf(value) !== -1;
    },
    getTreeData(keyword) {
      // this.getUser(keyword, '', '')
      let userPara = {
        Keyword: keyword,
        ListPostId: [],
        CurrentUserId: this.userId,
        ListCompanyDept: {
          CompanyId: "",
          DepId: "",
          CompanyGeneralCode: "",
          COmpanyName: "",
          DeptName: ""
        }
      };
      this.GetTemplateUserSearchResult(userPara, true);
      // this.GetUserByCustomerGroup(keyword)
    },
    GetTemplateUserSearchResult(userPara, isFirst) {
      this.loading = true;
      this.dataIniting = true;
      GetTemplateUserSearchResult(userPara).then(response => {
        console.log("GetTemplateUserSearchResult", response);
        this.treeList = this.treeList.concat(response);
        this.allData = response;

        this.userList = isFirst ? response : this.userList;
        this.loading = false;
      });
    },
    GetTemplateUserSearchResultByTemplateID(templateId, currentUserId) {
      this.loading = true;
      this.dataIniting = true;
      GetTemplateUserSearchResultByTemplateID(templateId, currentUserId).then(
        response => {
          // let dataArray = response
          // this.treeList = []
          console.log("GetTemplateUserSearchResultByTemplateID", response);
          this.treeList = this.treeList.concat(response);
          this.allData = response;

          if (response.length > 0) {
            this.$store.commit("setResult", response); //  右侧结果集赋值
            this.$store.state.resultBase.isResult = true; //判断当前是否点击结果集
          }
          this.loading = false;
        }
      );
    },
    getUser(keyword, companyId, deptId) {
      this.loading = true;
      getAllUser(this.userId, keyword, 0, companyId, deptId).then(response => {
        let dataArray = response;
        this.treeList = [];
        this.treeList = this.treeList.concat(response);
        this.allData = response; //listToTree('Id', 'Pid', dataArray)
        //如果table有数据，相同数据勾选上
        //默认勾选数组设为空
        this.expandedKeys = [];
        for (var j = 0; j < this.tableData.length; j++) {
          for (var i = 0; i < dataArray.length; i++) {
            if (dataArray[i].ID == this.tableData[j].ID) {
              //如果ID一样视为同一人，取消选中
              //this.$refs.companyTree.setChecked(dataArray[i].Id, true)
              this.expandedKeys.push(dataArray[i].Id);
            }
          }
        }
        //少于100展开节点
        // if (dataArray.length <= 100) {
        //     this.$refs.companyTree.store.defaultExpandAll = true
        // } else {
        //     this.$refs.companyTree.store.defaultExpandAll = false
        // }
        this.loading = false;
      });
    },
    getkeywordUser(keyword) {
      if (keyword !== "") {
        this.loading = true;
        this.getTreeData(keyword);
        // setTimeout(() => {
        //     this.loading = false;
        //     keyword = keyword.toLowerCase();
        //     this.allData = this.userList.filter(item => {
        //         return (
        //             item.Name.toLowerCase().indexOf(keyword) > -1 ||
        //             item.PY.toLowerCase().indexOf(keyword) > -1 ||
        //             item.FullPY.toLowerCase().indexOf(keyword) > -1
        //         );
        //     });
        // }, 200);
      } else {
        this.allData = this.userList;
      }
    },
    GetUserByCustomerGroup(keyword) {
      this.loading1 = true;
      GetUserTreeByCustomerGroup(this.userId, keyword).then(response => {
        let dataArray = response;
        this.treeList1 = [];
        this.treeList1 = this.treeList1.concat(response);
        this.data1 = listToTree("Id", "Pid", dataArray);
        //如果table有数据，相同数据勾选上
        //默认勾选数组设为空
        this.expandedKeys1 = [];
        for (var j = 0; j < this.tableData.length; j++) {
          for (var i = 0; i < dataArray.length; i++) {
            if (dataArray[i].ID == this.tableData[j].ID) {
              //如果ID一样视为同一人，取消选中
              this.expandedKeys1.push(dataArray[i].Id);
            }
          }
        }
        this.loading1 = false;
      });
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(val);
    },
    toSure(data) {
      this.userName = "";
      if (this.isRadio == true) {
        this.unverifiedSelectedUser = [this.currentRow];
      } else {
        this.unverifiedSelectedUser = [];
        this.tableData.forEach(c => {
          this.unverifiedSelectedUser.push(c); //存入未验证数组
        });
      }
      if (this.transferValue(this.unverifiedSelectedUser) == true) {
        this.toClose();
        this.dialogVisible = false;
      }
      if (!this.selectedUser) this.selectedUser = [];
      this.$emit("assignmentInput", this.selectedUser);
    },
    transferValue(unverifiedData) {
      let isValidate = true; //验证是否通过
      this.$emit("getValue", unverifiedData, function(str) {
        //传递值，无论是否验证
        isValidate = str;
      });
      if (isValidate) {
        //验证通过
        //内外公共操作一起处理
        this.selectedUser = [];
        unverifiedData.forEach(c => {
          this.selectedUser.push(c);
        }); //最终值进行处理
        return true;
      } else {
        //验证不通过
        this.unverifiedSelectedUser = [];
        return false;
      }
    },
    assignmentInput() {
      //input框赋值
      this.userName = "";
      this.selectedUser.forEach(c => {
        this.userName += c.Name + ",";
      });
      this.userName = this.userName.substring(
        0,
        this.userName.lastIndexOf(",")
      );
    },
    toClose() {
      //关闭弹窗前操作
      this.dataForIsRadio = {};
      this.filterText = "";
      this.editCheckId = "";
      this.tableData = [];
      this.$refs.multipleTable.clearSelection([]);
      this.allData = [];
      //this.$refs.companyTree.setCheckedKeys([]);
    },
    toCloseForm() {
      this.dataForIsRadio = {};
      this.filterText = "";
      this.editCheckId = "";
      this.editCheckIdArr = [];
      this.tableData = [];
      // this.$refs.companyTree.setCheckedKeys([]);
      this.$refs.multipleTable.clearSelection([]);
    },
    filter(arr1, arr2) {
      /*arr1 传被检测对象，arr2传已存在的列表*/
      var arrRet = [];
      for (var j = 0; j < arr1.length; j++) {
        var b = false;
        for (var i = 0; i < arr2.length; i++) {
          if (arr1[j].Type == 1 || arr1[j].Type == 3) {
            b = true;
            break;
          }
          if (arr1[j].UserId == arr2[i].UserId) {
            b = true;
            break;
          }
        }
        if (!b && arr1[j].Type == 2) {
          arrRet.push(arr1[j]);
        }
      }
      return arrRet;
    },
    getAllTask(data) {
      // 点击树结构模板动态查询
      if (data.TEMPTYPE == 0) {
        let content = JSON.parse(data.CONTENT);
        let queryTitle = content.queryTitle ? content.queryTitle : [];
        console.log("queryTitle", queryTitle);
        this.$store.state.template.searchCondition = queryTitle;
        this.GetTemplateUserSearchResult(content);
      } else if (data.TEMPTYPE == 1) {
        this.GetTemplateUserSearchResultByTemplateID(data.ID, this.userId);
      }
    },
    searchExpand(val) {
      this.expand = val;
    },
    redact(val) {
      // 编辑模板
      console.log("编辑模板", 1);
      if (val.TEMPTYPE == 1) {
        // this.$refs.resultAmend.dialogVisible = true;
        GetTemplateUserSearchResultByTemplateID(val.CONTENT, this.userId).then(
          res => {
            this.$store.state.template.tableData = res;
          }
        );
      } else {
        let content = JSON.parse(val.CONTENT);
        console.log("模板值", content);
        this.$store.commit("setQueryTask", content);
      }
    },
    morenTempS(val) {
      GetTemplateUserSearchResultByTemplateID(val, this.userId).then(res => {
        console.log(res, "结果集模板搜索");
        this.$store.state.template.taskSource = res;
        if (res.length > 0) {
          this.$store.commit("setResult", res);
          this.$store.state.resultBase.isResult = true;
        }
      });
    },
    searchTask() {
      this.$refs.userSearchDialog.SearchOpen();
    },
    //打开弹出框完成后回调，已有数据赋值
    openedDialog() {
      this.$refs.templateTag.getLeftAndAll();
    },
    OpenDialog(selectedUser) {
      // this.getTreeData('');

      this.selectedUser = selectedUser ? selectedUser : [];
      this.tableData = [];
      this.editCheckIdArr = [];
      if (this.selectedUser) {
        this.selectedUser.forEach(c => {
          this.tableData.push(c);
          this.editCheckIdArr.push(c.ID);
        });
      }
      console.log("人员控件内部选中值", this.tableData);
      this.$store.state.template.searchCondition = [];
      this.$store.state.template.category = 6;
      this.$store.state.template.isLookRecord = false;
      this.dialogVisible = true;
    }
  },
  computed: {
    searchCondition: function() {
      return this.$store.state.template.searchCondition;
    }
  }
};
</script>

<style scoped>
.userDialog >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}

#allUser >>> .el-button {
  padding: 11px 8px;
  margin: -10px 0px;
}

#allUserDialog .el-tree-node__label {
  font-size: 16px;
}

#allUserDialog .custom-tree-node {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  padding-right: 8px;
}

#allUserDialog .custom-tree-node img {
  vertical-align: top;
  margin-top: 4px;
}

#allUserDialog >>> .el-autocomplete-suggestion {
  width: 300px;
}

#allUser .el-input-group__append,
.el-input-group__prepend {
  padding: 0 0px;
}

#allUser .el-input-group__append button.el-button {
  /* border-color: transparent;*/
  /*background-color:none;*/
  color: inherit;
  border-top: 0;
  border-bottom: 0;
}

#userTemplateSearch .el-input__inner {
  width: 425px;
}

#userTemplateSearch1 .el-input__inner {
  /*border-radius: 18px;*/
  width: 425px;
}

/*.bounce-enter-active,
                                                	.bounce-leave-active {

transition: opacity .5s;
                                                	}
                                                	.bounce-enter,
                                                	.bounce-leave-to
                                                	{

opacity: 0;
                                                	}*/
.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1);
  }

  100% {
    transform: scale(1);
  }
}

.searchForm >>> .el-form-item {
  margin-right: 0px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.searchForm {
  background-color: #f5f7fa;
}

.isActiveClass {
  transform: rotate(90deg);
}

.beforeIcon {
  margin: 5px 8px 0 auto;
  transition: transform 0.4s;
}

.isActiveClass1 {
  transform: rotate(90deg);
}

.beforeIcon1 {
  margin: 5px 8px 0 auto;
  transition: transform 0.4s;
}
</style>
<style lang="less" scoped>
.userTemplate {
  /deep/ .el-dialog__body {
    // background-color: rgb(241, 246, 253);
    text-align: initial;
    padding: 5px 10px 15px 10px;
  }
}

.suspension {
  z-index: 500;
  position: absolute;
  top: 50%;
  right: 0px;
}

.userDialog {
  position: relative;
}
</style>
